<h4>Text Widget Editor</h4>


<mat-tab-group>
  <mat-tab label="Appearance">
    <div>
    <mat-form-field>
      <mat-label>Title Label</mat-label>
      <input matInput [(ngModel)]="widget.title" name="widget.title">
    </mat-form-field>
    </div>

    <widget-background-colour [widget]="widget"></widget-background-colour>
  </mat-tab>

  <mat-tab label="Data">
    <rich-text-editor [(html)]="widget.text"></rich-text-editor>
  </mat-tab>

  <mat-tab label="Interactivity"> Interactivity </mat-tab>

  <mat-tab label="Alerts"> Alerts </mat-tab>
</mat-tab-group>
